@if (has('format')) {
  <div class="admin-toolbar tw:mb-1">
    <button type="button" class="btn btn-secondary btn-sm" id="emailWordingFormat" data-markup-format
      [disabled]="loading" (click)="format()" title="Lay the HTML out one block per line. Text and placeholders are not changed.">Format</button>
  </div>
}

@if (loading) {
  <p class="tw:text-sm tw:text-gray-600" data-markup-loading>Loading the editor…</p>
}
@if (loadFailed) {
  <p class="tw:text-sm tw:text-red-600" role="alert" data-markup-failed>The editor could not be loaded. Reload the page to try again.</p>
}

<!-- CodeMirror mounts here. -->
<div #host data-markup-host [attr.data-features]="features.join(' ')"></div>

@if (missingRequired.length) {
  <p class="tw:mt-1 tw:text-sm tw:text-red-700" data-lint-missing role="status">
    Must stay in the wording:
    @for (t of missingRequired; track t.name) { <code class="tw:mr-1">{{written(t)}}</code> }
  </p>
}
